import FormikHomeAssumptionsAllianzAndLibertyOwnLivePage from './FormikHomeAssumptionsAllianzAndLibertyOwnLivePage';

export default FormikHomeAssumptionsAllianzAndLibertyOwnLivePage;
